import { render, staticRenderFns } from "./companyMsg.vue?vue&type=template&id=71cad63c&scoped=true"
import script from "./companyMsg.vue?vue&type=script&lang=js"
export * from "./companyMsg.vue?vue&type=script&lang=js"
import style0 from "@/styles/index.styl?vue&type=style&index=0&id=71cad63c&prod&lang=stylus&scoped=true&external"
import style1 from "./companyMsg.vue?vue&type=style&index=1&id=71cad63c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cad63c",
  null
  
)

export default component.exports